import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Layout from '../components/layout'
import Profile from '../components/profile'
import { Link } from 'gatsby'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

class HireTemplate extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    var posts = get(this, 'props.data.allAirtable.edges')
    var categories = get(this, 'props.data.categories.edges')
    const slug = get(this, 'props.pageContext.slug')
    const color = 'rgb(248, 232, 199)'
    const category = 'Hire'
    const description =
      'A series featuring underrepresented people in tech looking for jobs.'
    const type = get(this, 'props.pageContext.type')

    if (!posts) {
      posts = []
    }
    return (
      <Layout location={this.props.location} style={{ backgroundColor: color }}>
        <Helmet
          htmlAttributes={{ lang: 'en' }}
          meta={[
            { name: 'description', content: description },
            { property: 'og:title', content: category },
            {
              property: 'og:description',
              content: description,
            },
            {
              name: 'twitter:title',
              content: category,
            },
            {
              name: 'twitter:description',
              content: description,
            },
          ]}
          title={siteTitle}
        />

        <div className=" mx-auto max-w-screen-xl pt-6 md:p-12 md:pt-4">
          <div className="text-center p-4">
            <h2 className="text-3xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-4xl sm:leading-none md:text-5xl">
              Let's Change the Ratio
              <br />
              <span className="text-red-500">
                Hire underrepresented folks in tech
              </span>
            </h2>
            <p className="mt-3 max-w-md mx-auto text-base text-gray-600 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl leading-5">
              These are folks from our community who are looking for jobs. Reach
              out to them directly!
            </p>

            <OutboundLink
              href="https://airtable.com/shrbLTQbvmrWsw2YX"
              target="_blank"
              rel="noopener noreferrer"
              className="text-black"
            >
              <div>Get featured →</div>
            </OutboundLink>
          </div>

          <div className="max-w-xl mx-auto sm:max-w-none md:max-w-none lg:max-w-none pl-6 pr-6 text-center">
            <Link
              to="/hire/"
              className="inline-flex items-center px-4 py-2 border border-gray-300 text-base leading-6 rounded-md text-gray-700 bg-white hover:bg-red-500 hover:text-white focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150 m-2 no-underline hover:border-black"
              rel="noopener noreferrer"
            >
              All
            </Link>

            {categories.map(({ node }) => {
              if (node.data.Published) {
                return (
                  <Link
                    to={'/hire/' + node.data.Slug}
                    className={
                      'inline-flex items-center px-4 py-2 border border-gray-300 text-base leading-6 rounded-md focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 m-2 no-underline  no-underline' +
                      (slug == node.data.Slug
                        ? ' bg-red-500 text-white'
                        : ' text-gray-700 bg-white hover:bg-red-500 hover:text-white hover:border-black')
                    }
                    rel="noopener noreferrer"
                  >
                    {node.data.Name}
                  </Link>
                )
              }
            })}
          </div>

          <div className="mt-8 grid gap-5 max-w-xl mx-auto sm:grid-cols-2 sm:max-w-none md:grid-cols-2 md:max-w-none lg:grid-cols-3 lg:max-w-none pl-6 pr-6">
            {posts.map(({ node }) => {
              return (
                <Profile
                  key={node.data.Name}
                  data={node.data}
                  color={color}
                  type={type}
                  id={node.id}
                />
              )
            })}
          </div>
        </div>
      </Layout>
    )
  }
}

export default HireTemplate

export const pageQuery = graphql`
  query($category: String!) {
    site {
      siteMetadata {
        title
      }
    }

    categories: allAirtable(
      filter: { table: { eq: "Hire - Categories" } }
      sort: { fields: [data___Order], order: ASC }
    ) {
      edges {
        node {
          id
          data {
            Name
            Slug
            Order
            Published
          }
        }
      }
    }

    allAirtable(
      filter: { table: { eq: "Hire" }, data: { Category: { eq: $category } } }
      sort: { fields: [data___Created_Date], order: DESC }
    ) {
      edges {
        node {
          id
          data {
            Name
            Email
            Headshot {
              url
            }
            Short_Intro
            Role
            Location
            About_New_Role
            Available_Date(formatString: "MMMM Do, YYYY")
            Website
            LinkedIn_Page
            Twitter_Profile
            Github
            Pronoun
          }
        }
      }
    }
  }
`
